'use strict';

module.exports = {
    LANG: 'pt-br',
    SIGN: 'Entrar',
    REGISTER: 'Cadastre-se',
    QUICK_ACCESS: 'Acesso rápido com',
    SIGN_JOIN: 'Entre ou inscreva-se de graça',
    NOT_MEMBER: 'Você ainda não é um membro?',
    ALREADY_MEMBER: 'Você já é membro do AliExpress/Alibaba?',
    SHOW_ALL: 'Mostrar todas as',
    HIDE: 'Ocultar'
};